import React from 'react';

const formatCurrency = value => {
    if (!value || isNaN(value)) return '0 €';
    return parseFloat(value).toLocaleString('es-ES', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 2 
    }) + ' €';
};

const AlquilerDetails = ({ alquiler }) => (
    <div className="border-t pt-4">
        <h3 className="font-semibold text-green-700 mb-3">🏠 Datos de Alquiler</h3>
        <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="bg-green-50 p-3 rounded">
                <span className="text-sm text-gray-600">Precio Mensual:</span>
                <div className="font-bold text-lg text-green-700">{formatCurrency(alquiler.precioMensualEstimado)}</div>
            </div>
            <div className="bg-green-50 p-3 rounded">
                <span className="text-sm text-gray-600">Rentabilidad Anual:</span>
                <div className="font-bold text-lg text-green-700">{alquiler.rentabilidadAnual}%</div>
            </div>
            {alquiler.tiempoRetornoMeses && (
                <div className="bg-green-50 p-3 rounded col-span-2">
                    <span className="text-sm text-gray-600">Tiempo de Retorno:</span>
                    <div className="font-bold text-lg text-green-700">{alquiler.tiempoRetornoMeses} meses</div>
                </div>
            )}
        </div>
    </div>
);

export default AlquilerDetails; 